import i18n from '../i18n';

/**
 * Returns a BCP-47 locale string suitable for Intl APIs (toLocaleDateString,
 * Intl.NumberFormat, etc.) based on the current i18n.language.
 */
export function getDateLocale(): string {
  const lang = (i18n.language || 'no').slice(0, 2).toLowerCase();
  switch (lang) {
    case 'no': case 'nb': case 'nn': return 'nb-NO';
    case 'en': return 'en-US';
    case 'de': return 'de-DE';
    case 'pl': return 'pl-PL';
    case 'es': return 'es-ES';
    case 'fr': return 'fr-FR';
    case 'sv': return 'sv-SE';
    case 'da': return 'da-DK';
    default: return 'en-US';
  }
}
